import {
  NO_AVAILABLE_LEASING_TEAMS,
  NO_AVAILABLE_MANAGERS,
  SELECT_A_LEASING_TEAM,
  SELECT_A_PROPERTY_OWNER,
} from './constants';

export const getLeasingTeamRenderValue = (leasingTeams) => (val) => {
  if (leasingTeams === null) {
    return '';
  }
  if (val.leasingTeamName) {
    return val.leasingTeamName;
  }
  return leasingTeams.length === 0 ? NO_AVAILABLE_LEASING_TEAMS : SELECT_A_LEASING_TEAM;
};

export const getManagerRenderValue = (managers) => (val) => {
  if (managers === null) {
    return '';
  }
  if (val.label) {
    return val.label;
  }
  return managers.length === 0 ? NO_AVAILABLE_MANAGERS : SELECT_A_PROPERTY_OWNER;
};
